import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-form-search',
  templateUrl: './form-search.component.html',
  styleUrls: ['./form-search.component.sass']
})
export class FormSearchComponent implements OnInit {
  @Input()  resetable = true;
  @Input()  name = 'search';
  @Input()  term: string;
  @Input()  placeholder = '';
  @Output() termChange = new EventEmitter();
  @Output() keyPress = new EventEmitter();

  constructor() { }

  ngOnInit() {
    // if (this.term) {
    //   this.onTermChange();
    // }
  }

  onKeyPress() {
    this.keyPress.emit(this.term);
  }

  onTermChange() {
    this.termChange.emit(this.term);
  }

  onClearClick() {
    this.term = null;
    this.onTermChange();
  }
}
